import { forgotPassword as _forgotPassword } from '@griply/services';
import { httpsCallable } from 'firebase/functions';
import { getErrorReporter } from 'shared/services/error-tracking';
import { ForgotPasswordErrorTypes } from 'shared/types/forgot-password-form';

import { getFunctions } from './helpers';

export const forgotPassword = async (email: string) => {
  try {
    await _forgotPassword({ functions: getFunctions(), httpsCallable, email });
  } catch (e) {
    getErrorReporter().captureException(e, {
      tags: { source: 'firebase-forgot-password' },
    });
    throw ForgotPasswordErrorTypes.Unknown;
  }
};
